import { Grid, IconButton } from '@mui/material';
import { Fragment, memo } from 'react';
import { PmiInputFile } from 'shell/components/shared/file-input';
import DeleteIcon from '@mui/icons-material/Delete';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { DocumentVM } from 'civil-status/view-models/step-form';
import { DocumentWizard } from 'shell/models/document-wizard';
import PmiTextField from 'shell/components/shared/text-field';
import { getStateDocumentWizard } from 'civil-status/constants/id-state-document-wizard';

export const ID_TIPO_ALLEGATO_DESCRIZIONE_MANUALE = '998';

interface FormProps {
  disabled?: boolean;
  onChange: (key: keyof DocumentVM, value: DocumentVM[keyof DocumentVM]) => void;
  onChanges: (values: DocumentVM) => void;
  values?: DocumentVM;
  idEvento?: number;
  currentFile?: TypeFile;
  withDescription?: boolean;
  item: DocumentWizard;
  index: number;
  onTrashPress: (itemCurrent: DocumentWizard, idAllegato?: number) => void;
  handleAddFile: (file: File, item: DocumentWizard) => void;
  withError?: boolean;
  isStepFromEmergency?: boolean;
}

const FormComponent = ({
  disabled,
  onChange,
  values,
  currentFile,
  withDescription = false,
  item,
  index,
  onTrashPress,
  handleAddFile,
  withError = false,
  isStepFromEmergency = false,
}: FormProps): React.ReactElement => {
  const isObligatory = Boolean(
    values?.obligatoryFiles?.find((itemFind) => itemFind === item.key?.tipoAllegato)
  );

  return (
    <Fragment>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          {withDescription ? (
            <span
              style={{ color: withError && !Boolean(currentFile) && isObligatory ? 'red' : '' }}
            >
              {`${item.descrizioneTipoAllegato} ${isObligatory ? '*' : ''}`}
            </span>
          ) : (
            <PmiTextField
              aria-label="Descrizione"
              label="Descrizione"
              id="description"
              name="description"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.currentDescription || ''}
              onChange={(event) => onChange('currentDescription', event.target.value)}
              disabled={disabled}
            />
          )}
        </Grid>
        <Grid item xs={12} md={1}>
          <PmiInputFile
            file={currentFile}
            onChange={(file) => handleAddFile(file, item)}
            color="cdmBrandThird"
            showFilename={false}
            disabled={
              isStepFromEmergency ||
              disabled ||
              (withDescription ? Boolean(currentFile) : false) ||
              !(values?.currentDescription || withDescription)
            }
            multiple={false}
            id={`${item.key?.tipoAllegato || ''}-${index}`}
          />
        </Grid>
        {withDescription ? (
          Boolean(currentFile) ? (
            <>
              <Grid item xs={12} md={5}>
                {isStepFromEmergency ? (
                  currentFile?.name
                ) : (
                  <a download={currentFile?.name} href={currentFile?.raw}>
                    {currentFile?.name}
                  </a>
                )}
              </Grid>
              <Grid item xs={12} md={1}>
                <IconButton
                  color="error"
                  aria-label="eliminare documento allegato"
                  component="span"
                  onClick={() => onTrashPress(item, currentFile?.idAllegato || undefined)}
                  disabled={disabled || isStepFromEmergency}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
              <Grid item xs={12} md={2}>
                {getStateDocumentWizard(currentFile?.codStato)}
              </Grid>
            </>
          ) : undefined
        ) : (
          (values?.files || [])
            .filter(
              (itemAllegato) => itemAllegato.tipoAllegato === ID_TIPO_ALLEGATO_DESCRIZIONE_MANUALE
            )
            ?.map((itemFile) => (
              <Grid
                container
                spacing={2}
                item
                xs={12}
                key={`${itemFile.name}-${itemFile.idAllegato}`}
              >
                <Grid item xs={12} md={4}>
                  {values?.descriptions?.[`description-${item.key?.tipoAllegato}-${itemFile.name}`]}
                </Grid>
                <Grid item xs={12} md={5}>
                  {isStepFromEmergency ? (
                    itemFile.name
                  ) : (
                    <a
                      download={
                        values?.descriptions?.[
                          `description-${item.key?.tipoAllegato}-${itemFile.name}`
                        ]
                      }
                      href={itemFile?.raw}
                    >
                      {itemFile.name}
                    </a>
                  )}
                </Grid>
                <Grid item xs={12} md={1}>
                  <IconButton
                    color="error"
                    aria-label="eliminare documento allegato"
                    component="span"
                    onClick={() => onTrashPress(item, itemFile?.idAllegato || undefined)}
                    disabled={disabled}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={12} md={2}>
                  {getStateDocumentWizard(itemFile?.codStato)}
                </Grid>
              </Grid>
            ))
        )}
      </Grid>
    </Fragment>
  );
};

FormComponent.displayName = 'Form DATA - accordion document - form';

const FormData = memo(FormComponent);

export default FormData;
